export default {
      id: "icon-storelocator-usage",
      viewBox: "0 0 11 15",
      url: __webpack_public_path__ + "icons.svg#icon-storelocator",
      toString: function () {
        return this.url;
      }
    }